// The picker variant is the tallest: header + capped list + padding.
const ESTIMATED_CARD_HEIGHT = 260;
// The preview's 260px content plus the popover's padding and border.
const CARD_WIDTH = 280;
const VIEWPORT_MARGIN = 8;

export interface ReferencePopoverPosition {
    left: number;
    /** Set when the card sits above the pill; `top` is used instead when below. */
    bottom?: number;
    top?: number;
}

/**
 * Places the preview card next to a mention pill, preferring above but flipping
 * below and clamping horizontally to keep it on screen.
 */
export function referencePopoverPosition(
    rect: { top: number; bottom: number; left: number },
    viewport: { width: number; height: number } = {
        width: window.innerWidth,
        height: window.innerHeight,
    },
): ReferencePopoverPosition {
    const fitsAbove = rect.top >= ESTIMATED_CARD_HEIGHT + VIEWPORT_MARGIN;
    const maxLeft = viewport.width - CARD_WIDTH - VIEWPORT_MARGIN;

    return {
        left: Math.max(VIEWPORT_MARGIN, Math.min(rect.left, maxLeft)),
        ...(fitsAbove
            ? { bottom: viewport.height - rect.top + VIEWPORT_MARGIN }
            : { top: rect.bottom + VIEWPORT_MARGIN }),
    };
}
